// extracted by mini-css-extract-plugin
module.exports = {"header":"K6saHeader_header__2mODE","fileBlock":"K6saHeader_fileBlock__2n5TP"};